module.exports = __webpack_public_path__ + "img/exercise1.93a32f08.svg";